import type { CoreTechProps } from "@/components/ui/core-it-block/types";

export default function CoreTechMobile(props: CoreTechProps) {
    const { items } = props;

    if (items?.length === 0) return null;

    return (
        <svg
            viewBox="-101 180 577 1070"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-full h-auto"
        >
            <path
                d="M184.833 485C184.833 486.473 186.027 487.667 187.5 487.667C188.973 487.667 190.167 486.473 190.167 485C190.167 483.527 188.973 482.333 187.5 482.333C186.027 482.333 184.833 483.527 184.833 485ZM188 383V382.5H187V383H187.5H188ZM187.5 485H188V383H187.5H187V485H187.5Z"
                fill="url(#paint0_linear_4671_31706)"
            />
            <path
                d="M184.833 661C184.833 662.473 186.027 663.667 187.5 663.667C188.973 663.667 190.167 662.473 190.167 661C190.167 659.527 188.973 658.333 187.5 658.333C186.027 658.333 184.833 659.527 184.833 661ZM188 607L188 606.5L187 606.5L187 607L187.5 607L188 607ZM187.5 661L188 661L188 607L187.5 607L187 607L187 661L187.5 661Z"
                fill="url(#paint3_linear_4671_31706)"
            />
            <path
                d="M184.833 841C184.833 842.473 186.027 843.667 187.5 843.667C188.973 843.667 190.167 842.473 190.167 841C190.167 839.527 188.973 838.333 187.5 838.333C186.027 838.333 184.833 839.527 184.833 841ZM188 787L188 786.5L187 786.5L187 787L187.5 787L188 787ZM187.5 841L188 841L188 787L187.5 787L187 787L187 841L187.5 841Z"
                fill="url(#paint6_linear_4671_31706)"
            />
            <path
                d="M184.833 1021C184.833 1022.47 186.027 1023.67 187.5 1023.67C188.973 1023.67 190.167 1022.47 190.167 1021C190.167 1019.53 188.973 1018.33 187.5 1018.33C186.027 1018.33 184.833 1019.53 184.833 1021ZM188 967L188 966.5L187 966.5L187 967L187.5 967L188 967ZM187.5 1021L188 1021L188 967L187.5 967L187 967L187 1021L187.5 1021Z"
                fill="url(#paint9_linear_4671_31706)"
            />

            <rect
                x="16"
                y="486"
                width="343"
                height="120"
                rx="16"
                fill="url(#paint1_linear_4671_31706)"
                fillOpacity="0.1"
            />
            <rect
                x="16.5"
                y="486.5"
                width="342"
                height="119"
                rx="15.5"
                stroke="url(#paint2_linear_4671_31706)"
                strokeOpacity="0.4"
            />
            <foreignObject x="34" y="500" width="310" height="50">
                <div className="text-white break-words text-xl">{items?.[1]?.title}</div>
            </foreignObject>
            <foreignObject x="34" y="540" width="310" height="50">
                <div className="text-[#EBEFF4] break-words">{items?.[1]?.description}</div>
            </foreignObject>

            <rect
                x="16"
                y="662"
                width="343"
                height="124"
                rx="16"
                fill="url(#paint4_linear_4671_31706)"
                fillOpacity="0.1"
            />
            <rect
                x="16.5"
                y="662.5"
                width="342"
                height="123"
                rx="15.5"
                stroke="url(#paint5_linear_4671_31706)"
                strokeOpacity="0.4"
            />
            <foreignObject x="34" y="680" width="310" height="50">
                <div className="text-white break-words text-xl">{items?.[3]?.title}</div>
            </foreignObject>
            <foreignObject x="34" y="720" width="310" height="50">
                <div className="text-[#EBEFF4] break-words">{items?.[3]?.description}</div>
            </foreignObject>

            <rect
                x="16"
                y="842"
                width="343"
                height="124"
                rx="16"
                fill="url(#paint7_linear_4671_31706)"
                fillOpacity="0.1"
            />
            <rect
                x="16.5"
                y="842.5"
                width="342"
                height="123"
                rx="15.5"
                stroke="url(#paint8_linear_4671_31706)"
                strokeOpacity="0.4"
            />
            <foreignObject x="34" y="860" width="310" height="50">
                <div className="text-white break-words text-xl">{items?.[2]?.title}</div>
            </foreignObject>
            <foreignObject x="34" y="900" width="310" height="50">
                <div className="text-[#EBEFF4] break-words">{items?.[2]?.description}</div>
            </foreignObject>

            <rect
                x="16"
                y="1022"
                width="343"
                height="124"
                rx="16"
                fill="url(#paint10_linear_4671_31706)"
                fillOpacity="0.1"
            />
            <rect
                x="16.5"
                y="1022.5"
                width="342"
                height="123"
                rx="15.5"
                stroke="url(#paint11_linear_4671_31706)"
                strokeOpacity="0.4"
            />
            <foreignObject x="34" y="1040" width="310" height="50">
                <div className="text-white break-words text-xl">{items?.[0]?.title}</div>
            </foreignObject>
            <foreignObject x="34" y="1080" width="310" height="50">
                <div className="text-[#EBEFF4] break-words">{items?.[0]?.description}</div>
            </foreignObject>

            <g filter="url(#filter0_f_4671_31706)">
                <circle cx="188.363" cy="402.222" r="47.2217" fill="#89BCED" fillOpacity="0.7" />
            </g>

            <g filter="url(#filter1_f_4671_31706)">
                <circle cx="188" cy="402" r="165" fill="#157DB3" fillOpacity="0.3" />
            </g>

            <g clipPath="url(#clip0_4671_31706)">
                <path
                    d="M227.508 369.347C227.508 369.827 227.419 370.281 227.241 370.69C227.063 371.109 226.822 371.465 226.52 371.776C226.208 372.088 225.852 372.328 225.434 372.506C225.016 372.684 224.571 372.773 224.09 372.773C223.592 372.773 223.138 372.684 222.728 372.515C222.319 372.346 221.963 372.106 221.66 371.803C221.358 371.5 221.126 371.135 220.966 370.726C220.797 370.308 220.708 369.863 220.708 369.364C220.708 368.884 220.797 368.43 220.975 368.02C221.153 367.602 221.393 367.246 221.696 366.935C222.007 366.623 222.363 366.392 222.782 366.214C223.2 366.036 223.645 365.947 224.126 365.947C224.624 365.947 225.078 366.036 225.487 366.205C225.897 366.374 226.253 366.614 226.555 366.917C226.858 367.219 227.089 367.584 227.25 367.994C227.436 368.403 227.508 368.857 227.508 369.347ZM226.849 369.4C226.849 368.964 226.787 368.581 226.635 368.225C226.502 367.869 226.306 367.575 226.075 367.317C225.834 367.059 225.541 366.872 225.211 366.739C224.882 366.605 224.526 366.543 224.135 366.543C223.725 366.543 223.351 366.623 223.004 366.766C222.657 366.917 222.372 367.122 222.141 367.371C221.901 367.629 221.723 367.923 221.589 368.261C221.456 368.59 221.393 368.946 221.393 369.329C221.393 369.765 221.456 370.148 221.607 370.504C221.74 370.86 221.936 371.153 222.168 371.411C222.408 371.669 222.702 371.856 223.022 371.99C223.351 372.123 223.707 372.186 224.099 372.186C224.517 372.186 224.9 372.106 225.229 371.963C225.576 371.821 225.861 371.607 226.093 371.358C226.333 371.1 226.511 370.806 226.644 370.468C226.778 370.13 226.849 369.774 226.849 369.4ZM225.701 371.073C225.701 371.091 225.701 371.118 225.692 371.135C225.683 371.153 225.674 371.171 225.639 371.18C225.603 371.189 225.559 371.189 225.505 371.198C225.452 371.207 225.372 371.207 225.274 371.207C225.185 371.207 225.122 371.207 225.06 371.198C225.007 371.189 224.962 371.189 224.918 371.162C224.882 371.153 224.855 371.127 224.829 371.109C224.802 371.091 224.793 371.055 224.784 371.011L224.588 370.37C224.508 370.13 224.41 369.961 224.304 369.872C224.197 369.774 224.019 369.729 223.796 369.729H223.538V371.064C223.538 371.118 223.52 371.153 223.476 371.189C223.431 371.207 223.334 371.224 223.164 371.224C222.995 371.224 222.889 371.216 222.844 371.189C222.8 371.171 222.782 371.127 222.782 371.064V367.753C222.782 367.647 222.817 367.558 222.871 367.478C222.924 367.415 223.013 367.38 223.138 367.38H224.099C224.357 367.38 224.562 367.397 224.749 367.442C224.927 367.486 225.078 367.567 225.203 367.656C225.327 367.745 225.416 367.869 225.47 368.003C225.523 368.136 225.559 368.287 225.559 368.457C225.559 368.741 225.478 368.982 225.327 369.133C225.176 369.284 224.962 369.4 224.695 369.462C224.838 369.507 224.971 369.596 225.096 369.703C225.22 369.827 225.327 369.987 225.425 370.228L225.656 370.833C225.683 370.975 225.701 371.046 225.701 371.073ZM224.704 368.537C224.704 368.474 224.695 368.394 224.669 368.341C224.651 368.279 224.615 368.216 224.562 368.172C224.508 368.127 224.437 368.083 224.339 368.065C224.25 368.047 224.126 368.02 223.983 368.02H223.529V369.115H223.965C224.241 369.115 224.446 369.062 224.544 368.964C224.651 368.848 224.704 368.715 224.704 368.537Z"
                    fill="white"
                />
                <path
                    d="M199.472 422.07L187.671 428.888V415.208L199.472 408.391V422.07Z"
                    fill="white"
                />
                <path
                    d="M175.869 422.07L187.671 428.888V415.208L175.869 408.391V422.07Z"
                    fill="white"
                />
                <path
                    d="M199.472 438.642L187.662 445.459V431.78L199.472 424.972V438.642Z"
                    fill="white"
                />
                <path
                    d="M175.86 438.642L187.662 445.459V431.78L175.86 424.972V438.642Z"
                    fill="white"
                />
                <path
                    d="M199.472 364.409L187.662 357.592V371.271L199.472 378.08V364.409Z"
                    fill="white"
                />
                <path
                    d="M175.86 364.409L187.662 357.592V371.271L175.86 378.08V364.409Z"
                    fill="white"
                />
                <path
                    d="M225.647 409.904V423.53L213.801 416.695V403.069L225.647 409.904Z"
                    fill="white"
                />
                <path
                    d="M213.846 430.347L225.647 423.53L213.801 416.695L202 423.503L213.846 430.347Z"
                    fill="white"
                />
                <path
                    d="M199.517 381.112L211.318 387.93L199.472 394.765L187.671 387.956L199.517 381.112Z"
                    fill="white"
                />
                <path
                    d="M211.319 401.556V387.93L199.473 394.765V408.391L211.319 401.556Z"
                    fill="white"
                />
                <path
                    d="M213.863 372.809L225.665 379.617L213.819 386.461L202.018 379.644L213.863 372.809Z"
                    fill="white"
                />
                <path
                    d="M225.665 393.252V379.617L213.819 386.461V400.087L225.665 393.252Z"
                    fill="white"
                />
                <path
                    d="M149.694 409.904V423.53L161.54 416.695V403.069L149.694 409.904Z"
                    fill="white"
                />
                <path
                    d="M161.496 430.347L149.694 423.53L161.54 416.695L173.342 423.503L161.496 430.347Z"
                    fill="white"
                />
                <path
                    d="M175.825 381.112L164.023 387.93L175.869 394.765L187.671 387.956L175.825 381.112Z"
                    fill="white"
                />
                <path
                    d="M164.023 401.556V387.93L175.869 394.765V408.391L164.023 401.556Z"
                    fill="white"
                />
                <path
                    d="M161.478 372.809L149.677 379.617L161.523 386.461L173.324 379.644L161.478 372.809Z"
                    fill="white"
                />
                <path
                    d="M149.677 393.252V379.617L161.523 386.461V400.087L149.677 393.252Z"
                    fill="white"
                />
            </g>

            <defs>
                <filter
                    id="filter0_f_4671_31706"
                    x="41.1416"
                    y="255"
                    width="294.443"
                    height="294.443"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    />
                    <feGaussianBlur stdDeviation="50" result="effect1_foregroundBlur_4671_31706" />
                </filter>

                <filter
                    id="filter1_f_4671_31706"
                    x="-50%"
                    y="-50%"
                    width="200%"
                    height="200%"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    />
                    <feGaussianBlur stdDeviation="48" result="effect1_foregroundBlur_4671_31706" />
                </filter>

                <linearGradient
                    id="paint0_linear_4671_31706"
                    x1="188"
                    y1="383"
                    x2="188"
                    y2="485"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.000456252" stopColor="#020506" />
                    <stop offset="1" stopColor="#78B2E5" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_4671_31706"
                    x1="152.534"
                    y1="426"
                    x2="296.142"
                    y2="588.107"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4E9BBF" />
                    <stop offset="0.529973" stopColor="#4E9BBF" stopOpacity="0.6" />
                    <stop offset="1" stopColor="#4E9BBF" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_4671_31706"
                    x1="115.903"
                    y1="399.913"
                    x2="366.451"
                    y2="552.426"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4E9BBF" />
                    <stop offset="0.192167" stopColor="#4E9BBF" stopOpacity="0" />
                    <stop offset="0.767991" stopColor="#4E9BBF" stopOpacity="0" />
                    <stop offset="1" stopColor="#4E9BBF" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_4671_31706"
                    x1="188"
                    y1="607"
                    x2="188"
                    y2="661"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.000456252" stopColor="#020506" />
                    <stop offset="1" stopColor="#78B2E5" />
                </linearGradient>
                <linearGradient
                    id="paint4_linear_4671_31706"
                    x1="152.534"
                    y1="600"
                    x2="301.438"
                    y2="762.663"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4E9BBF" />
                    <stop offset="0.529973" stopColor="#4E9BBF" stopOpacity="0.6" />
                    <stop offset="1" stopColor="#4E9BBF" />
                </linearGradient>
                <linearGradient
                    id="paint5_linear_4671_31706"
                    x1="115.903"
                    y1="573.043"
                    x2="370.825"
                    y2="723.214"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4E9BBF" />
                    <stop offset="0.192167" stopColor="#4E9BBF" stopOpacity="0" />
                    <stop offset="0.767991" stopColor="#4E9BBF" stopOpacity="0" />
                    <stop offset="1" stopColor="#4E9BBF" />
                </linearGradient>
                <linearGradient
                    id="paint6_linear_4671_31706"
                    x1="188"
                    y1="787"
                    x2="188"
                    y2="841"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.000456252" stopColor="#020506" />
                    <stop offset="1" stopColor="#78B2E5" />
                </linearGradient>
                <linearGradient
                    id="paint7_linear_4671_31706"
                    x1="152.534"
                    y1="780"
                    x2="301.438"
                    y2="942.663"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4E9BBF" />
                    <stop offset="0.529973" stopColor="#4E9BBF" stopOpacity="0.6" />
                    <stop offset="1" stopColor="#4E9BBF" />
                </linearGradient>
                <linearGradient
                    id="paint8_linear_4671_31706"
                    x1="115.903"
                    y1="753.043"
                    x2="370.825"
                    y2="903.214"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4E9BBF" />
                    <stop offset="0.192167" stopColor="#4E9BBF" stopOpacity="0" />
                    <stop offset="0.767991" stopColor="#4E9BBF" stopOpacity="0" />
                    <stop offset="1" stopColor="#4E9BBF" />
                </linearGradient>
                <linearGradient
                    id="paint9_linear_4671_31706"
                    x1="188"
                    y1="967"
                    x2="188"
                    y2="1021"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.000456252" stopColor="#020506" />
                    <stop offset="1" stopColor="#78B2E5" />
                </linearGradient>
                <linearGradient
                    id="paint10_linear_4671_31706"
                    x1="152.534"
                    y1="960"
                    x2="301.438"
                    y2="1122.66"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4E9BBF" />
                    <stop offset="0.529973" stopColor="#4E9BBF" stopOpacity="0.6" />
                    <stop offset="1" stopColor="#4E9BBF" />
                </linearGradient>
                <linearGradient
                    id="paint11_linear_4671_31706"
                    x1="115.903"
                    y1="933.043"
                    x2="370.825"
                    y2="1083.21"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4E9BBF" />
                    <stop offset="0.192167" stopColor="#4E9BBF" stopOpacity="0" />
                    <stop offset="0.767991" stopColor="#4E9BBF" stopOpacity="0" />
                    <stop offset="1" stopColor="#4E9BBF" />
                </linearGradient>
                <clipPath id="clip0_4671_31706">
                    <rect
                        width="89"
                        height="89"
                        fill="white"
                        transform="translate(143.18 357.18)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}
